module.exports = __webpack_public_path__ + "img/52114122_L.3dc06362.png";